export default {"src":"/_next/static/media/Spinner.7bddefb7.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};